import styled from 'styled-components';

export default styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-inline-start: 6px;
`;
